import React, { Component } from 'react';
import SelectBtn from './structure/SelectBtn';

class ContentDetail extends Component {
  state = {
    name: this.props.info['name'],
    url: this.props.info['url'],
    urlThumb: this.props.info['urlThumb'],
    elems : this.props.elems,
    from: this.props.from
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      name: nextProps.info['name'],
      url: nextProps.info['url'],
      urlThumb: nextProps.info['urlThumb'],
      elems : nextProps.elems
    })
  } 
  
  render(){
    const { name, url, urlThumb, from } = this.state;
    const { round } = this.props;
    return(
      <div className={`content-detail content-detail-${from}`}>
        {/* <div className={`${this.state.id} example`} onClick={this.props.onClick}>{this.props.id}</div> */}
        <img src={url} alt="" className={`${name} example`} onClick={this.props.onClick}/>
        {/* <span>{name}</span> */}
        <br />
        <SelectBtn text={name} url={urlThumb} from={from} round={round} onClick={this.props.onImgClick}/>
      </div>
    );
  }
}
export default ContentDetail;